__turbopack_context__.v({
  "column": "CoreColumn-module-scss-module__M5Zera__column",
});
